export const hasCompleteWagonNumbers = (count, numbers) =>
  Array.isArray(numbers) &&
  numbers.length === count &&
  numbers.every((number) => typeof number === "string" && number.trim().length > 0);
